import { ResolverResult } from 'interfaces/entity-resolver'
import { EntityNameParser } from './entity-name-parser'
import { EntityApiService } from './entity-api'
import { RouteBuilder } from './route-builder'

export class EntityResolver {
  /**
   * Main resolver method: name → route
   */
  static async resolve(entityName: string): Promise<ResolverResult> {
    try {
      // Step 1: Parse entity name
      const parsedEntity = EntityNameParser.parse(entityName.toUpperCase())

      // Step 2: Get entity IDs from API
      const entityIds = await EntityApiService.resolveEntityIds(parsedEntity)

      // Step 3: Build route
      const route = RouteBuilder.buildRoute(parsedEntity, entityIds)

      return {
        route,
        entityIds,
        parsedEntity,
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Unknown error'
      console.error(
        `❌ EntityResolver: Failed to resolve '${entityName}':`,
        error
      )
      throw new Error(
        `Failed to resolve entity '${entityName}': ${errorMessage}`
      )
    }
  }
}
